export const getAccountIdByFilter = (
  walletFilter,
  filterVariables,
  operatorId,
) => {
  switch (walletFilter) {
    case "1":
      return operatorId;
    case "2":
      return filterVariables.selectedPartnerId;
    case "3":
      // For branch level, return the first selected branch ID
      return filterVariables.selectedPartnerBranch?.[0]?.value || null;
    case "4":
      // For agent level, return the first selected agent ID
      return filterVariables.selectedPartnerAgent?.[0]?.value || null;
    default:
      return null;
  }
};
